import { sign, verify, decode } from "jsonwebtoken";

export const JWT_SECRET = process.env.NEXT_PUBLIC_SECRET_KEY;
export const REFRESH_SECRET = process.env.NEXT_PUBLIC_REFRESH_KEY;
export const JWT_EXPIRES_IN = "1h";
export const REFRESH_TOKEN_EXPIRES_IN = "30d";

export const signToken = (payload) => {
  return sign(payload, JWT_SECRET, { expiresIn: JWT_EXPIRES_IN });
};

export const signRefreshToken = (payload) => {
  return sign(payload, REFRESH_SECRET, { expiresIn: REFRESH_TOKEN_EXPIRES_IN });
};

export const verifyToken = (token) => {
  try {
    return verify(token, JWT_SECRET);
  } catch (error) {
    throw new Error("Invalid or expired token");
  }
};

export const verifyRefreshToken = (token) => {
  try {
    return verify(token, REFRESH_SECRET);
  } catch (error) {
    throw new Error("Invalid or expired token");
  }
};

export const decodeToken = (token) => {
  const now = new Date();

  const payload = decode(token);
  payload.isExpired = false;

  if (now > new Date(payload.exp * 1000)) {
    payload.isExpired = true;
  }

  return payload;
};
